var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../shared/nunjucks.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/alejandro.lorenzo/Desktop/Projects/cloudmine-panel-core/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/chart-block.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"cm-chart-block\">\r\n    <h1 class=\"page-header\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += " <small>by day and hour</small></h1>\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-8 col-md-9\">\r\n            <h4>By day</h4>\r\n            <div class=\"cm-chart-daily cm-chart\"></div>\r\n            <h4>By hour</h4>\r\n            <div class=\"cm-chart-hourly cm-chart\"></div>\r\n        </div>\r\n        <div class=\"col-xs-4 col-md-3\">\r\n            <div class=\"cm-filter-block\">\r\n                <h4>Filters</h4>\r\n                <div class=\"cm-filters\"></div>\r\n            </div>\r\n            <div class=\"cm-filter-block\">\r\n                <h4>Time interval</h4>\r\n                <div class=\"cm-time-range\"></div>\r\n            </div>\r\n            <div class=\"cm-filter-block\">\r\n                <h4>Selected days</h4>\r\n                <div class=\"cm-dates\"></div>\r\n            </div>\r\n            <hr>\r\n            <div class=\"btn-group\">\r\n                <a class=\"btn btn-sm btn-danger cm-reset\" role=\"button\" title=\"Reset filters\" href=\"#\">\r\n                    <i class=\"fa fa-undo\"></i> Reset filters\r\n                </a>\r\n                <a class=\"btn btn-sm btn-success cm-refresh\" role=\"button\" title=\"Reload data\" href=\"#\">\r\n                    <i class=\"fa fa-sync\"></i> Refresh\r\n                </a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/chart-block.html"] , dependencies)